import React from "react";
import { cn } from "@/utils/helpers/classnames";

interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
  children: React.ReactNode;
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  weight?: string;
  className?: string;
  onClick?: () => void;
}

const Heading: React.FC<HeadingProps> = ({ 
  children, 
  level = 1, 
  weight = "font-bold", 
  className = "", 
  onClick, 
  ...rest 
}) => {
  const Tag = `h${level}` as "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  
  const sizeClasses = {
    1: "text-xl md:text-2xl lg:text-3xl xl:text-[2rem]",
    2: "text-lg md:text-xl lg:text-2xl xl:text-2xl",
    3: "text-xl",
    4: "text-lg",
    5: "text-lg",
    6: "text-lg"
  };
  
  const weightClasses = {
    1: "font-bold",
    2: "font-semibold",
    3: "font-semibold",
    4: "font-semibold",
    5: "font-medium",
    6: "font-medium"
  };
  
  return (
    <Tag
      onClick={onClick}
      className={cn(
        "text-text-primary font-inter leading-normal",
        weight,
        sizeClasses[level],
        weightClasses[level],
        className
      )}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Heading;